import { Store } from 'vuex';
import { boot } from 'quasar/wrappers';
import { StateInterface } from '../store';

// Add a typed version of the store to Vue's interface.
declare module 'vue/types/vue' {
  interface Vue {
    $tStore: Store<StateInterface>;
  }
}

// Alias the store in the prototype as the typed version.
export default boot(({ app, Vue }) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  Vue.prototype.$tStore = app.store;
});
